module.exports = __webpack_public_path__ + "images/accents/accent-content-labels-2a29342d69bf86f7ac1f7966a2560f82.webp";